import React from 'react'
import Navbar from '../inc/Navbar'
import AddQueries from '../AddQueries'
import { Link } from "react-router-dom";
import logothehopingsunexim from "../images/LOGO_NEW-THSE.jpg";

function Enquiry() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br/>
            <div className='exportindian'>
                    <div className="album py-1">
                        <div className="container mt-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Enquiry</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            <div className='colorb'>
                <br />
              
               
                <div className="album py-02">
                    <div className="container">
                        <div className="card" >
                           
                            <center>
                            <img src={logothehopingsunexim} className="mt-3" width="300px"  height="100px" alt="logothehopingsunexim"/>
                            </center>
                                         

                            <div className="card-body">
                                <center>
                                    <h5 className="card-title">Enter your Your Comment </h5>
                                    <p className="card-text mb-4">Enter your PAN number for identity verification and exporter processing.</p>
                                </center>
                                <AddQueries />
                            </div>

                        </div>
                    </div>
                </div>
                <br />
                <br />
                <br />
                <br />
            </div>
        </div>
    )
}

export default Enquiry